export default __webpack_public_path__ + "static/media/logo2.76a6d5f1.png";